export default function PrivacyConsentCheckbox({
  checked,
  onChange,
  error,
  id = "privacy_consent",
}) {
  return (
    <div>
      <label htmlFor={id} className="flex items-start gap-2 text-sm cursor-pointer">
        <input
          id={id}
          name="privacy_consent"
          type="checkbox"
          required
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-input text-primary focus:ring-2 focus:ring-ring"
        />
        <span className="text-muted-foreground leading-snug">
          By proceeding, you confirm that you have read and understand our{" "}
          <a
            href="/privacy"
            target="_blank"
            rel="noreferrer"
            className="text-primary hover:underline"
          >
            Privacy Policy
          </a>{" "}
          and consent to the collection, use, and disclosure of your personal
          information, or your child's personal information if applicable, in
          accordance with it.
        </span>
      </label>
      {error && <p className="mt-1.5 text-xs text-destructive">{error}</p>}
    </div>
  );
}
